import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ListItemCardCst from "@components/ListItemCardCst";
import { useCardActions } from "@hooks/useCardActions";
import { mapGroupToCard } from "../mapGroupToCard";
import { UGEntityType } from "../types";

export interface GroupItemHandlers {
  onEnroll: (group: any) => void;
  onViewLO: (group: any) => void;
  onEdit: (group: any) => void;
  onDelete: (group: any) => void;
}

interface GroupItemProps extends GroupItemHandlers {
  group: any;
  entityType: Extract<UGEntityType, "group-static" | "group-dynamic">;
  corporateId?: string;
  selected: boolean;
  onSelect: (next: boolean) => void;
  onOpenDetail?: (group: any) => void;
}

const GroupItem: React.FC<GroupItemProps> = ({
  group,
  entityType,
  corporateId,
  selected,
  onSelect,
  onEnroll,
  onViewLO,
  onEdit,
  onDelete,
  onOpenDetail,
}) => {
  const overrides = useMemo(
    () => ({
      enroll: () => onEnroll(group),
      "view-lo": () => onViewLO(group),
      edit: () => onEdit(group),
      delete: () => onDelete(group),
    }),
    [group, onEnroll, onViewLO, onEdit, onDelete],
  );

  const moreActions = useCardActions(entityType, group, {
    corporateId,
    overrides,
  });

  const { t: tCard } = useTranslation("list-item-card");
  const cardProps = mapGroupToCard(group);

  const actions = onOpenDetail
    ? [
        {
          label: tCard("actions.details"),
          variant: "outlined" as const,
          onClick: () => onOpenDetail(group),
        },
      ]
    : undefined;

  return (
    <ListItemCardCst
      {...cardProps}
      selectable
      selected={selected}
      onSelect={onSelect}
      actions={actions}
      moreActions={moreActions}
      onClick={onOpenDetail ? () => onOpenDetail(group) : undefined}
    />
  );
};

export default GroupItem;
